import * as React from "react";
import { Show, ShowController, ReferenceManyField, Pagination, TabbedShowLayout, Datagrid, List, RichTextField, Tab, useRecordContext, Button, TextField, FunctionField } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'
import { Link } from 'react-router-dom';
const PageTitle = () => {
  const record = useRecordContext();
  return <span>User {record ? `${record.name}` : ''}</span>;
};
const PostPagination = ({ record, ...props }) => {
  return (<Pagination rowsPerPageOptions={[10, 20, 30, 50, 100, { value: props.total, label: 'All' }]} {...props} />)
}
const ProfileidFiled = (props) => {
  const record = useRecordContext();
  console.log(record.user.profile_id);
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record?record.user.profile_id:''}"}`} onClick={(event) => event.stopPropagation()} />
  )
}
const UserNameFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record?record.user.profile_id:''}"}`} onClick={(event) => event.stopPropagation()} />
  )
}
const UppercaseField = ({ source, ...rest }) => (
    <FunctionField
        source={source}
        render={record => {
            const value = record?.[source];
            return value ? String(value).toUpperCase() : '';
        }}
        {...rest}
    />
);

const StarHealthDetail = ({ ...props }) => {
  const classes = useStyles();
  const useperview = useCheckPermissions('StarHealth_View');

  return (
    <ShowController {...props}>
      {controllerProps =>
        <Show title="User Detail "  {...props}>

          <TabbedShowLayout>
            <Tab label="Summary">
              <ProfileidFiled source="user.profile_id" label="Profile Id" />
              <UserNameFiled source='user.name' label="User Name" />
              <UppercaseField source='name' label="Proposer Name" />
              <FunctionField source="status" label="Status" render={record => {

                if (record['status'] === 'Rejected') {
                  return (<span style={{ color: 'red' }}>Reject</span>)
                } else if (record['status'] === 'Pending') {
                  return (<span style={{ color: 'orange' }} >Pending</span>)
                }
                else {
                  return (<span style={{ color: 'green' }}>Approved</span>)
                }
              }} />


              <UppercaseField source='doornumber' label='Door Number' />
              <UppercaseField source='streetname' label='Street Name' />
              <UppercaseField source='cityname' label='City Name' />
              <UppercaseField source='postalcode' label='Postal Code' />
              <UppercaseField source='taluck' label='Taluck' />
              <UppercaseField source='district' label='District' />
              <UppercaseField source='mobile' label='Mobile' />
              <UppercaseField source='dob' label='Date of Birth' />
              <UppercaseField source='email' label='Email' />
              <UppercaseField source='weight' label='Weight' />
              <UppercaseField source='height' label='Height' />
              <UppercaseField source='pancard' label='Pan Card' />
              <UppercaseField source='occupation' label='Occupation' />
              <UppercaseField source='anualincome' label='Annual Income' />
              <UppercaseField source='nominee_name' label='Nominee Name' />
              <UppercaseField source='nominee_relation' label='Nominee Relation' />
              <UppercaseField source='nominee_dob' label='Nominee Date of Birth' />
              <UppercaseField source='nominee_pancard' label='Nominee Pan Card' />
              <UppercaseField source='nominee_aadhaar' label='Nominee Aadhaar' />
              <UppercaseField source='pre_existing_deseas' label='Pre Existing Diseases' />
              <UppercaseField source='pre_existing_deseas_duration' label='Pre Existing Diseases Duration' />
              <UppercaseField source='taking_medicine' label='Taking Medicine' />
              <UppercaseField source='taking_medicine_duration' label='Taking Medicine Duration' />
              <UppercaseField source='issurgery' label='Is Surgery' />
              <UppercaseField source='surgery_commends' label='Surgery Comments' />
              <UppercaseField source='family_count' label='Family Count' />
              <UppercaseField source='approved_by' label='Approved By' />
              <UppercaseField source='Rejected_by' label='Rejected By' />
              <UppercaseField source='Rejected_reason' label='Rejected Reason' />
              <FunctionField source="proposer_photo" label="Proposer Photo" render={record => {
                if (record['proposer_photo']) {
                  return (<img style={{ maxWidth: '100px' }} src={record['proposer_photo']} alt={record.name} />)
                }
              }} />
              <FunctionField source="proposer_aadhaar_front" label="Proposer Aadhaar Front" render={record => {
                if (record['proposer_aadhaar_front']) {
                  return (<img style={{ maxWidth: '100px' }} src={record['proposer_aadhaar_front']} alt={record.name} />)
                }
              }} />
              <FunctionField source="proposer_aadhaar_back" label="Proposer Aadhaar Back" render={record => {
                if (record['proposer_aadhaar_back']) {
                  return (<img style={{ maxWidth: '100px' }} src={record['proposer_aadhaar_back']} alt={record.name} />)
                }
              }} />
              <FunctionField source="proposer_pan" label="Proposer Pan" render={record => {
                if (record['proposer_pan']) {
                  return (<img style={{ maxWidth: '100px' }} src={record['proposer_pan']} alt={record.name} />)
                }
              }} />
              <FunctionField source="proposer_bank_book" label="Proposer Bank Book" render={record => {
                if (record['proposer_bank_book']) {
                  return (<img style={{ maxWidth: '100px' }} src={record['proposer_bank_book']} alt={record.name} />)
                }
              }} />




              <UppercaseField source='approved_date' label='Approved Date' />
              <UppercaseField source='Rejected_at' label='Rejected At' />
              <UppercaseField source='created_at' label="Date" />
            </Tab>
            {useperview ?
              <Tab label="Family Details">
                <ReferenceManyField pagination={<PostPagination />} reference={'healthcarefamily'} target="id" label="" filter={{ profile_id: controllerProps.record ? controllerProps.record.health_id : 0 }} addLabel={false} >
                  <Datagrid bulkaction={null} classes={{ row: classes.row }} >
                    <UppercaseField source="id" />
                    <UppercaseField source="name" label="Name" sortable={false} />
                    <UppercaseField source="dob" label="dob" sortable={false} />
                    <UppercaseField source="anualincome" label="Annual Income" sortable={false} />
                    <UppercaseField source="occupation" label="Occupation" sortable={false} />
                    <UppercaseField source="gender" label="Gender" sortable={false} />
                    <UppercaseField source="weight" label="Weight" sortable={false} />
                    <UppercaseField source="height" label="Height" sortable={false} />
                    <UppercaseField source="pre_existing_deseas" label="Pre Existing Deseas" sortable={false} />
                    <UppercaseField source="pre_existing_deseas_duration" label="Pre Existing Deseas Duration" sortable={false} />
                    <UppercaseField source="surgery_commends" label="Surgery Commends" sortable={false} />
                  </Datagrid>
                </ReferenceManyField>
              </Tab>
              : null}
            {useperview ?
              <Tab label="Bank Details">
                <UppercaseField source='bankholdername' label='Bank Holder Name' />
                <UppercaseField source='bankaccountnumber' label='Bank Account Number' />
                <UppercaseField source='bankname' label='Bank Name' />
                <UppercaseField source='branchname' label='Branch Name' />
                <UppercaseField source='ifsccode' label='IFSC' />
              </Tab>
              : null}


          </TabbedShowLayout>
        </Show>
      }
    </ShowController>
  )
};
const useStyles = makeStyles({
  row: { verticalAlign: "top" },
  actionCell: { width: 100 },
  imageCell: { width: 160 },
  idCell: { width: 80 }
});
export default StarHealthDetail